/* eslint-disable @typescript-eslint/no-deprecated */

import * as React from 'react'
import styled from 'styled-components'
import { Breakpoint } from '../../styles'

const MOB_WIDTH = '350'

interface CompanyItemContainerProps {
  clickable?: boolean
}

export interface OtherListItemProps {
  text: string
  containerStyle?: React.CSSProperties
  adornment?: React.ReactNode
}

export const OtherListItem: React.FC<OtherListItemProps> = ({ text, containerStyle, adornment }) => {
  return (
    <CompanyItemContainer style={containerStyle}>
      <FlexBox>
        <div
          style={{
            alignSelf: 'stretch',
            minWidth: '0.55rem',
          }}
        />
        <div
          style={{
            height: '100%',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            flex: 1,
            padding: '1rem 0',
          }}
        >
          <Text>
            <p>{text}</p>
          </Text>
          {adornment != null ? adornment : null}
        </div>
      </FlexBox>
    </CompanyItemContainer>
  )
}

const CompanyItemContainer = styled.div<CompanyItemContainerProps>`
  border-bottom: ${({ theme }) => theme.colors.grey.medium} 1px solid;
  color: ${({ theme }) => theme.colors.dark};
  cursor: ${(props) => (props.clickable ? 'pointer' : 'inherit')};
  flex: 0 0 30%;
  @media (max-width: ${Breakpoint.tablet}) {
    width: ${MOB_WIDTH} !important;
    flex: 100% !important;
  }
`

const FlexBox = styled.div`
  display: flex;
  align-items: center;
`

const Text = styled.div`
  margin-left: 0.5rem;
  margin-right: 5px;
  flex-grow: 1;
  font-size: 1.4rem;
`
